export function fadeOut(target: HTMLElement, callback?: () => void): void {
    if (window.getComputedStyle(target).opacity === '0') {
        callback?.();
        return;
    }
    const onEnd = (e: TransitionEvent) => {
        if (e.propertyName !== 'opacity') return;
        target.removeEventListener('transitionend', onEnd);
        callback?.();
    };
    target.addEventListener('transitionend', onEnd);
    target.classList.add('order_js_fadeOut');
}
